import React from "react";

export const MobileDeleteIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3v1h5v2h-1v13c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6H4V4h5V3h6zM7 19h10V6H7v13zM9 8h2v9H9V8zm6 0h-2v9h2V8z"
        fill="#fff"
      />
    </svg>
  );
};

export const CloseWhiteIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
        fill="#fff"
      />
    </svg>
  );
};

export const EditIconDarkBig = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19.06 3.59 1.35 1.35c.79.78.79 2.05 0 2.83L7.18 21H3v-4.18L13.4 6.41l2.83-2.82c.78-.78 2.05-.78 2.83 0zM5 19l1.41.06 9.82-9.83-1.41-1.41L5 17.64V19z"
        fill="#777"
      />
    </svg>
  );
};

export const PreviewEyeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#ghn7cif9fa)">
        <path
          d="M8 4.333c2.527 0 4.78 1.42 5.88 3.667A6.506 6.506 0 0 1 8 11.667 6.506 6.506 0 0 1 2.12 8 6.513 6.513 0 0 1 8 4.333zM8 3C4.667 3 1.82 5.073.667 8c1.153 2.927 4 5 7.333 5 3.334 0 6.18-2.073 7.334-5-1.154-2.927-4-5-7.334-5zm0 3.333a1.667 1.667 0 1 1 0 3.335 1.667 1.667 0 0 1 0-3.335zM8 5C6.347 5 5 6.347 5 8s1.347 3 3 3c1.654 0 3-1.347 3-3S9.654 5 8 5z"
          fill="#777"
        />
      </g>
      <defs>
        <clipPath id="ghn7cif9fa">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditIconDark = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m12.707 2.393.9.9c.526.52.526 1.367 0 1.887L4.787 14H2v-2.787l6.933-6.94 1.887-1.88c.52-.52 1.367-.52 1.887 0zM3.333 12.667l.94.04 6.547-6.554-.94-.94-6.547 6.547v.907z"
        fill="#777"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2v.667h3.333V4h-.667v8.667c0 .733-.6 1.333-1.333 1.333H4.666c-.733 0-1.333-.6-1.333-1.333V4h-.667V2.667H6V2h4zM4.667 12.667h6.666V4H4.666v8.667zM6 5.333h1.333v6H6v-6zm4 0H8.666v6H10v-6z"
        fill="#777"
      />
    </svg>
  );
};

export const LiveChatMobIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#iblk53rp3a)">
        <path
          d="M19.7 3H5.3a1.8 1.8 0 0 0-1.793 1.8L3.5 20.997l3.6-3.6h12.6a1.8 1.8 0 0 0 1.8-1.8V4.8A1.8 1.8 0 0 0 19.7 3zm-9.902 8.099H8v-1.8h1.8l-.002 1.8zm3.6 0h-1.8v-1.8h1.8v1.8zm3.6 0h-1.8v-1.8h1.8v1.8z"
          fill="#777"
        />
        <path d="M17.84 8.81H7.085v2.868H17.84V8.81z" fill="#777" />
        <path
          d="M17.123 7.376H7.802v.717h9.321v-.717zM17.123 9.527H7.802v.717h9.321v-.717zM17.123 11.678H7.802v.717h9.321v-.717z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="iblk53rp3a">
          <path fill="#fff" transform="translate(3.5 3)" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LiveAgentMobIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#y48bgbc9na)">
        <path
          d="M19.7 3H5.3a1.8 1.8 0 0 0-1.793 1.8L3.5 20.997l3.6-3.6h12.6a1.8 1.8 0 0 0 1.8-1.8V4.8A1.8 1.8 0 0 0 19.7 3zm-9.902 8.099H8v-1.8h1.8l-.002 1.8zm3.6 0h-1.8v-1.8h1.8v1.8zm3.6 0h-1.8v-1.8h1.8v1.8z"
          fill="#777"
        />
      </g>
      <defs>
        <clipPath id="y48bgbc9na">
          <path fill="#fff" transform="translate(3.5 3)" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BroadcastMobIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
        fill="#2A2D2E"
      />
    </svg>
  );
};
export const SmallSaveIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#6zsyo7meua)">
        <path
          d="M14.658 2.992a1.672 1.672 0 0 0-1.183-.492H4.167c-.925 0-1.667.75-1.667 1.667v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V6.525c0-.442-.175-.867-.492-1.175l-2.35-2.358zM10 15.833a2.497 2.497 0 0 1-2.5-2.5c0-1.383 1.117-2.5 2.5-2.5s2.5 1.117 2.5 2.5c0 1.384-1.117 2.5-2.5 2.5zm.833-8.333h-5c-.916 0-1.666-.75-1.666-1.667 0-.916.75-1.666 1.666-1.666h5c.917 0 1.667.75 1.667 1.666 0 .917-.75 1.667-1.667 1.667z"
          fill="#777"
        />
      </g>
      <defs>
        <clipPath id="6zsyo7meua">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BackArrowButton = ({ color }) => {
  const arrowColor = color === "white" ? "#ffffff" : "#2A2D2E";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
        fill={arrowColor}
      />
    </svg>
  );
};

export const SmallCrossIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
        fill="#2A2D2E"
      />
    </svg>
  );
};

export const FileUploadIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 11.25v2.25h-9v-2.25H3v2.25c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-2.25h-1.5zm-8.25-4.5 1.058 1.058L8.25 5.872V12h1.5V5.872l1.943 1.936L12.75 6.75 9 3 5.25 6.75z"
        fill="#fff"
      />
    </svg>
  );
};

export const LogIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#u46pq83v2a)">
        <path
          d="M4.125 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1s.45 1 1 1zm-1-9c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1zm-3 5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1s.45 1 1 1zm-1-9c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1z"
          fill="#777"
        />
      </g>
      <defs>
        <clipPath id="u46pq83v2a">
          <path fill="#fff" transform="translate(.125)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QuestionCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#9g7puyigca)">
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2v-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47z"
          fill="#777"
        />
      </g>
      <defs>
        <clipPath id="9g7puyigca">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#23r36jbeqa)">
        <path
          d="M13.714 3.214v.729a6.075 6.075 0 0 1 4.858 5.95v.713c0 1.787.656 3.507 1.84 4.842l.28.315a1.213 1.213 0 0 1-.906 2.023H5.215a1.214 1.214 0 0 1-.908-2.023l.281-.315a7.288 7.288 0 0 0 1.84-4.842v-.713a6.041 6.041 0 0 1 4.858-5.95v-.729a1.214 1.214 0 1 1 2.428 0zM12.5 21.43a2.43 2.43 0 0 1-1.719-.71 2.49 2.49 0 0 1-.71-1.719h4.858a2.49 2.49 0 0 1-.71 1.719 2.49 2.49 0 0 1-1.719.71z"
          fill="#777"
        />
      </g>
      <defs>
        <clipPath id="23r36jbeqa">
          <path fill="#fff" transform="translate(4 2)" d="M0 0h17v19.429H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SmallSearchIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m11.07 9.953 4.297 4.297-1.117 1.117-4.297-4.297c-.803.578-1.77.93-2.828.93A4.875 4.875 0 1 1 12 7.125a4.817 4.817 0 0 1-.93 2.828zM7.125 3.75A3.37 3.37 0 0 0 3.75 7.125 3.37 3.37 0 0 0 7.125 10.5 3.37 3.37 0 0 0 10.5 7.125 3.37 3.37 0 0 0 7.125 3.75z"
        fill="#BEBFC0"
      />
    </svg>
  );
};

export const SmallReportIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.86 5.752H6.13a.505.505 0 0 1 0-1.01h5.728a.505.505 0 1 1 0 1.01h.002zm.506 1.87a.506.506 0 0 0-.506-.506H6.13a.505.505 0 0 0 0 1.01h5.728a.506.506 0 0 0 .506-.505h.002zm0 2.374a.506.506 0 0 0-.506-.505H6.13a.505.505 0 1 0 0 1.01h5.728a.506.506 0 0 0 .508-.504v-.001zm2.59 5.726V2.493a.994.994 0 0 0-.986-.993H3.996A.995.995 0 0 0 3 2.493v13.23a.995.995 0 0 0 .996.993h9.974a.995.995 0 0 0 .987-.993zm-1.012 0H4.013V2.511h9.948l-.017 13.211z"
        fill="#BEBFC0"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6.667h-.833V5C14.167 2.7 12.3.833 10 .833A4.168 4.168 0 0 0 5.833 5v1.667H5c-.917 0-1.667.75-1.667 1.667v8.333c0 .916.75 1.666 1.667 1.666h10c.917 0 1.667-.75 1.667-1.666V8.333c0-.916-.75-1.666-1.667-1.666zm-5 7.5c-.917 0-1.667-.75-1.667-1.667 0-.916.75-1.666 1.667-1.666s1.667.75 1.667 1.666c0 .917-.75 1.667-1.667 1.667zm-2.5-7.5V5c0-1.383 1.117-2.5 2.5-2.5s2.5 1.117 2.5 2.5v1.667h-5z"
        fill="#00B2E3"
      />
    </svg>
  );
};
